import { Field, Model, CodeModel, FIELD_TYPES } from "@/vue-ocom/schema";

export default Model("form_template_permission", {
  verbose_name: "Form Template Permission",
  verbose_name_plural: "Form Template Permissions",
  fields: [
    Field("id", {
      label: "ID",
      primary_key: true,
      readonly: true,
      hide: false,
      field_type: FIELD_TYPES.AutoNumber,
    }),

    Field("allow_view", {
      label: "Allow View",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Boolean,
      default: () => {
        return true;
      },
    }),
    Field("allow_create", {
      label: "Allow Create",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Boolean,
      default: () => {
        return true;
      },
    }),
    Field("allow_update", {
      label: "Allow Update",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Boolean,
      default: () => {
        return true;
      },
    }),
    Field("form_template_version", {
      label: "Form Template Version",
      primary_key: false,
      readonly: false,
      required: false,
      hide: false,
      field_type: FIELD_TYPES.ForeignKey,
      ref_field_type: "FormTemplateVersion",
      ref_display_field: "uuid",
      default: () => {
        return null;
      },
    }),
    Field("form_template_version__uuid", {
      label: "Form Template Version",
      primary_key: false,
      readonly: true,
      required: false,
      hide: false,
      field_type: FIELD_TYPES.String,
      default: () => {
        return null;
      },
    }),

    Field("group", {
      label: "Group",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Number,
      default: () => {
        return null;
      },
    }),
  ],
});
